import React from 'react';
import {
    getLatestDance,
    getVideoUrl,
    captureUserMedia,
    S3Upload,
    generateID,
    saveToDatabase,
    captureVideoFrame,
    getDance
} from './AppUtils';
//import Webcam from './Webcam.react';
import RecordRTC from 'recordrtc';
import ReactAudioPlayer from 'react-audio-player';
import CountdownTimer from './CountdownTimer';

import {browserHistory} from 'react-router';

const hasGetUserMedia = !!(navigator.getUserMedia || navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia || navigator.msGetUserMedia);

const VIDEO_LENGTH = 15 * 1000;
var progressInterval;

class RecordPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            progress: 0,
            recordVideo: null,
            stream: null,
            src: null,
            countdown: false,
            count: 10,
            uploadSuccess: null,
            instructions: true,
            recording: false,
            uploading: false,
            naming: false,
            width: 640,
            height: 480,
            id: null,
            videoName: "",
            dancerName: "",
            dancerLocation: "",
            vs: null, // this is when they are going against someone else
            vsVideoSrc: null,
            booth: false
        };

        this.requestUserMedia = this.requestUserMedia.bind(this);
        this.startCountdown = this.startCountdown.bind(this);
        this.startRecord = this.startRecord.bind(this);
        this.stopRecord = this.stopRecord.bind(this);
        this.cancelRecord = this.cancelRecord.bind(this);
        this.saveVideo = this.saveVideo.bind(this);
        this.setVideoLoop = this.setVideoLoop.bind(this);

        this.startVs = this.startVs.bind(this);
        this.stopVs = this.stopVs.bind(this);

        this.enableWebcam = this.enableWebcam.bind(this);

        this.updateDancerName = this.updateDancerName.bind(this);
        this.updateDancerLocation = this.updateDancerLocation.bind(this);
    }

    componentDidMount() {
        if (!hasGetUserMedia) {
            alert("Your browser cannot record from your webcam. Please switch to Chrome or Firefox.");
            return;
        }
        //this.requestUserMedia();

        if (this.props.location.pathname.indexOf("booth") != -1) {
            this.setState({
                booth: true,
                videoName: "The Kiosk",
                dancerName: "CMCArts",
                dancerLocation: "St. Croix"
            });
        }

        if (this.props.params.danceId) {
            this.setState({vs: this.props.params.danceId});
            getDance(this.props.params.danceId)
                .then((success) => {
                    var videoSrc = getVideoUrl() + success.data.dances[success.data.dances.length - 1].id + ".webm";
                    this.setState({vsVideoSrc: videoSrc});
                });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            (this.state.recording && this.state.recording !== prevState.recording) ||
            (this.state.countdown && this.state.countdown !== prevState.countdown) ||
            (!this.state.instructions && !!prevState.instructions)) {
            const video = document.querySelector('#myVidPlayer');
            window.navigator.mediaDevices.getUserMedia({video: true})
                .then(stream => {
                    video.srcObject = stream;
                    video.onloadedmetadata = (e) => {
                        video.play();
                    };
                });


        }
    }

    enableWebcam() {
        this.requestUserMedia();
        this.setState({instructions: false});
    }

    requestUserMedia() {
        console.log('requestUserMedia')
        captureUserMedia((stream) => {
            this.setState({src: window.URL.createObjectURL(stream)});
            console.log('setting state', this.state)
        });
    }

    startCountdown() {
        var iv;
        this.setState({countdown: true});

        this.audioTen.audioEl.play();

        iv = setInterval(function () {
            var c = this.state.count;
            if (c == "DANCE") {
                this.setState({count: 10, countdown: false});
                clearInterval(iv);
                this.startRecord();
            } else {
                c--;
                switch (c) {
                    case 0:
                        c = "DANCE";
                        this.audioDance.audioEl.play();
                        break;
                    case 1:
                        this.audioOne.audioEl.play();
                        break;
                    case 2:
                        this.audioTwo.audioEl.play();
                        break;
                    case 3:
                        this.audioThree.audioEl.play();
                        break;
                    case 4:
                        this.audioFour.audioEl.play();
                        break;
                    case 5:
                        this.audioFive.audioEl.play();
                        break;
                    case 6:
                        this.audioSix.audioEl.play();
                        break;
                    case 7:
                        this.audioSeven.audioEl.play();
                        break;
                    case 8:
                        this.audioEight.audioEl.play();
                        break;
                    case 9:
                        this.audioNine.audioEl.play();
                        break;
                    case 10:
                        this.audioTen.audioEl.play();
                        break;

                }


                this.setState({count: c})
            }

        }
            .bind(this), 1200);
    }

    startRecord() {
        this.setState({recording: true, id: generateID()});

        this.startVs();

        captureUserMedia((stream) => {
            var options = {
                type: 'video',
                audio: false,
                frameInterval: 10,
                video: {
                    mandatory: {
                        maxHeight: 720,
                        maxWidth: 1280
                    },
                    optional: [
                        {minWidth: 320},
                        {minWidth: 640},
                        {minWidth: 960},
                        {minWidth: 1024},
                        {minWidth: 1280}
                    ]
                }
            };
            this.state.recordVideo = RecordRTC(stream, options);
            this.state.recordVideo.startRecording();
            this.startProgress();
        });

        setTimeout(() => {
            if (this.state.recording) {
                //this.stopRecord();
            }
        }, VIDEO_LENGTH);

    }

    cancelRecord() {
        clearInterval(progressInterval);

        this.stopVs();

        this.requestUserMedia();

        this.setState({progress: 0, recording: false, naming: false});
        this.state.recordVideo.stopRecording(() => {

        });
    }

    stopRecord() {
        this.state.recordVideo.stopRecording(() => {
            var naming = true,
                uploading = false;

            if (this.state.booth) {
                naming = false;
                uploading = true;
            }

            if (this.state.vs) {

                this.setState({
                    recording: false,
                    uploading: uploading,
                    naming: naming,
                    src: window.URL.createObjectURL(this.state.recordVideo.blob)
                }, function () {
                    this.setVideoLoop();

                    if (uploading) {
                        setTimeout(function () {
                            this.saveVideo();
                        }.bind(this), 2000);

                    }
                    /*this.startVs();
                    this.saveVideo();*/
                });
            } else {
                this.setState({
                    recording: false,
                    uploading: uploading,
                    naming: naming,
                    src: window.URL.createObjectURL(this.state.recordVideo.blob)
                }, function () {
                    this.setVideoLoop();
                    if (uploading) {
                        setTimeout(function () {
                            this.saveVideo();
                        }.bind(this), 2000);
                    } else {
                        this.refs.videoName.focus();
                    }


                });
            }

        });
    }

    setVideoLoop() {
        var videoElement = this.refs.video;

        videoElement.play();
        videoElement.onended = function () {
            videoElement.play();
            //videoElement.pause();
            // dirty workaround for: "firefox seems unable to playback"
            //videoElement.src = this.props.src;
        }.bind(this);


        if (this.state.vs && !this.state.naming) {
            var videoElement2 = this.refs.videoVs;

            videoElement2.play();
            videoElement2.onended = function () {
                videoElement2.play();
                //videoElement.pause();
                // dirty workaround for: "firefox seems unable to playback"
                //videoElement.src = this.props.src;
            }.bind(this);
        }
    }

    saveVideo() {
        let params = {
            type: 'video/webm',
            data: this.state.recordVideo.blob,
            id: this.state.id
        }

        this.setState({
            uploading: true,
            recording: false,
            naming: false
        }, function () {
            if (this.state.vs) {
                this.setVideoLoop();
            }
        });


        //var videoRef = this.refs.video;

        /*
        captureUserMedia((stream) => {
          stream.getTracks()[0].stop();
        });
        */

        var frame = captureVideoFrame(this.refs.video, "jpeg");

        S3Upload(params)
            .then((success) => {
                if (success) {
                    console.log("Upload video Success");


                    params = {
                        type: 'image/jpeg',
                        data: frame.blob,
                        id: this.state.id
                    }

                    console.log("uploading thumbnail");
                    S3Upload(params)
                        .then((success) => {
                            if (success) {
                                console.log("thumbnail save success");
                                // save to server

                                var currentDance = null;
                                if (this.state.vs) {
                                    currentDance = this.props.params.danceId;
                                }

                                saveToDatabase(this.state.id, this.state.videoName, this.state.dancerName, this.state.dancerLocation, currentDance)
                                    .then((success) => {
                                        if (!this.state.booth) {
                                            browserHistory.push('/watch');
                                        } else {
                                            getLatestDance()
                                                .then((success) => {
                                                    if (success.dances.length == 4) {
                                                        browserHistory.push('/thanks');
                                                    } else {
                                                        browserHistory.push('/thanks/' + success._id);
                                                    }
                                                });
                                        }

                                    });
                            }
                        }, (error) => {
                            alert("Couldn't save thumbnail");
                        });


                }
            }, (error) => {
                alert(error, 'error occurred. check your aws settings and try again.')
            });
    }


    startProgress() {
        this.setState({progress: 0});
        var counter = 0;
        progressInterval = setInterval(function () {
            var count = counter * (VIDEO_LENGTH / 100) / VIDEO_LENGTH * 100;
            this.setState({progress: count});
            counter++;

            if (VIDEO_LENGTH / 100 * counter > VIDEO_LENGTH) {
                clearInterval(progressInterval);
                this.stopRecord();
            }
            //this.setState({progress: x});
        }.bind(this), VIDEO_LENGTH / 100);
    }

    updateName(evt) {
        this.setState({
            videoName: evt.target.value
        });
    }

    updateDancerName(evt) {
        this.setState({
            dancerName: evt.target.value
        });
    }

    updateDancerLocation(evt) {
        this.setState({
            dancerLocation: evt.target.value
        });
    }

    //<Webcam src={this.state.src} width={this.state.width} height={this.state.height} />


    startVs() {
        if (this.state.vs) {
            this.refs.videoVs.currentTime = 0;
            this.refs.videoVs.play();
        }
    }

    stopVs() {
        if (this.state.vs && !this.state.naming) {
            this.refs.videoVs.pause();
            this.refs.videoVs.currentTime = 0;
        }
    }

    render() {
        var percentage = this.state.progress + "%";
        var hi = {width: '100%'};

        const {
            width,
            fullWidth,
            height,
            fullHeight,
            progress,
            naming,
            vsVideoSrc,
            dancerName,
            dancerLocation,
            src,
            countdown,
            count,
            booth,
            recording
        } = this.state;

        var vs = {
            width: 480
        };

        if (naming || this.state.vs) {
            vs = {
                width: 480 * 2
            }
        }

        var boothBtn = "Enable Webcam";
        var enableMessage = "Enable webcam and get ready to dance!";
        if (booth) {
            boothBtn = "Got it";
            enableMessage = "Get ready to dance!"
        }
        return (
            <div className="recorder full">
                <div>

                    <ReactAudioPlayer ref={c => {
                        this.audioTen = c
                    }} src="/audio/beep.wav" preload="auto"/>

                    <ReactAudioPlayer ref={c => {
                        this.audioNine = c
                    }} src="/audio/beep.wav" preload="auto"/>

                    <ReactAudioPlayer ref={c => {
                        this.audioEight = c
                    }} src="/audio/beep.wav" preload="auto"/>

                    <ReactAudioPlayer ref={c => {
                        this.audioSeven = c
                    }} src="/audio/beep.wav" preload="auto"/>

                    <ReactAudioPlayer ref={c => {
                        this.audioSix = c
                    }} src="/audio/beep.wav" preload="auto"/>

                    <ReactAudioPlayer ref={c => {
                        this.audioFive = c
                    }} src="/audio/beep.wav" preload="auto"/>
                    <ReactAudioPlayer ref={c => {
                        this.audioFour = c
                    }} src="/audio/beep.wav" preload="auto"/>
                    <ReactAudioPlayer ref={c => {
                        this.audioThree = c
                    }} src="/audio/3.mp3" preload="auto"/>
                    <ReactAudioPlayer ref={c => {
                        this.audioTwo = c
                    }} src="/audio/2.mp3" preload="auto"/>
                    <ReactAudioPlayer ref={c => {
                        this.audioOne = c
                    }} src="/audio/1.mp3" preload="auto"/>
                    <ReactAudioPlayer ref={c => {
                        this.audioDance = c
                    }} src="/audio/dance.mp3" preload="auto"/>
                </div>

                {this.state.instructions ?
                    <div className="instructions table">
                        <div className="table-cell">
                            <div className="instructions-inner">
                                <div className="instructions-video">
                                    <video autoPlay loop className="videoSquare"
                                           src="https://s3.amazonaws.com/dancing2medev/b5af1a3b-b94c-16de-92fd-fa2975042c02.webm"></video>
                                </div>
                                <h1>HOW TO DANCE</h1>
                                <ol>
                                    <li>Move back until your whole body fills the frame</li>
                                    <li>Always face the dancer</li>
                                    <li>{enableMessage}</li>
                                </ol>
                                <button onClick={this.enableWebcam}>{boothBtn}</button>
                            </div>
                        </div>
                    </div> : null}
                {naming ?
                    <div className="flash"/> : null}

                {countdown ?
                    <div className="countdown">
                        <div className="table">
                            <div className="table-cell">
                                <div className='front-camera-stream-box'>
                                    <video
                                        muted
                                        id='myVidPlayer'
                                        controls={false}
                                        autoplay
                                    /> 
                                    <CountdownTimer number={count}/>
                                </div>
                            </div>
                        </div>
                    </div> : null}

                <div className="table">
                    <div className="table-cell">

                        {this.state.vs ?
                            <div className={`vs ${progress !== 100 ? 'fullWidth' : 'mainWidth'}`}>
                                <div
                                    className={`left ${progress !== 100 ? 'fullWidth' : ''}`}>
                                    {!naming ?
                                        <div className={`videoOuter ${progress !== 100 ? 'fullWidth' : ''}`}>
                                            <div className="videoCrop">
                                                <video
                                                    className="flip"
                                                    ref="videoVs"
                                                    muted
                                                    width={progress !== 100 ? fullWidth : width}
                                                    height={progress !== 100 ? fullHeight : height}
                                                    src={vsVideoSrc}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div className="table">
                                            <div className="table-cell">
                                                <div className="naming">
                                                    <div>
                                                        <label>Your Name:</label>
                                                        <input ref="dancerName" type="text" placeholder=""
                                                               className="dancerName" name="dancerName"
                                                               onChange={this.updateDancerName.bind(this)}
                                                               value={dancerName}/>
                                                    </div>
                                                    <div>
                                                        <label>Your Location:</label>
                                                        <input ref="dancerLocation" type="text" placeholder=""
                                                               className="dancerLocation" name="dancerLocation"
                                                               onChange={this.updateDancerLocation.bind(this)}
                                                               value={dancerLocation}/>
                                                    </div>
                                                    <div>
                                                        <button className="btn-submit" onClick={this.saveVideo}>Save
                                                        </button>
                                                        <button className="btn-reset"
                                                                onClick={this.cancelRecord}>Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className={`right ${progress !== 100 ? 'hide' : ''}`}>
                                    <div className="videoOuter">
                                        <div className="videoCrop">
                                            <video className="flip" ref="video"
                                                   autoPlay
                                                   muted
                                                   width={width}
                                                   height={height}
                                                   src={src}/>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            :
                            <div className="vs" style={vs}>
                                <div className="left">
                                    <div className="videoOuter">
                                        <div className="videoCrop">
                                            <video className="flip" ref="video" autoPlay muted width={width}
                                                   height={height} src={src}/>
                                        </div>
                                    </div>
                                </div>
                                {naming ?
                                    <div className="right">
                                        <div className="table">
                                            <div className="table-cell">
                                                <div className="naming">
                                                    <div>
                                                        <label>Dance Name:</label>
                                                        <input ref="videoName" type="text" placeholder=""
                                                               className="videoName" name="videoName"
                                                               onChange={this.updateName.bind(this)}
                                                               value={this.state.videoName}/>
                                                    </div>
                                                    <div>
                                                        <label>Your Name:</label>
                                                        <input ref="dancerName" type="text" placeholder=""
                                                               className="dancerName" name="dancerName"
                                                               onChange={this.updateDancerName.bind(this)}
                                                               value={this.state.dancerName}/>
                                                    </div>
                                                    <div>
                                                        <label>Your Location:</label>
                                                        <input ref="dancerLocation" type="text" placeholder=""
                                                               className="dancerLocation" name="dancerLocation"
                                                               onChange={this.updateDancerLocation.bind(this)}
                                                               value={this.state.dancerLocation}/>
                                                    </div>
                                                    <div>
                                                        <button className="btn-submit" onClick={this.saveVideo}>Save
                                                        </button>
                                                        <button className="btn-reset"
                                                                onClick={this.cancelRecord}>Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null}
                            </div>
                        }


                        {this.state.recording || this.state.uploading || this.state.uploadSuccess || this.state.naming ?
                            null : <div>
                                <button className="btn-start" onClick={this.startCountdown}>Record</button>
                            </div>}
                    </div>
                </div>

                {this.state.recording ?
                    <div className="progress" style={{width: percentage}}></div> : null}

                {this.state.recording ?
                    <button className="btn-cancel" onClick={this.cancelRecord}>Cancel</button> : null}


                {this.state.uploading ?
                    <div className="uploading">
                        <span><span></span></span>
                    </div> : null}


            </div>
        )
    }
}

export default RecordPage;



// WEBPACK FOOTER //
// src/RecordPage.react.js